import type { ComponentPropsWithoutRef, FC, ChangeEvent } from "react";
import { useCallback, useRef } from "react";
import { useIntl } from "react-intl";
import { CSSTransition } from "react-transition-group";

import { animationDuration } from "../../../NavigationBar/theme";
import { useAccountSwitcherContext } from "../../AccountSwitcherContext";
import { Icon } from "../../SwitcherIcon";
import {
  StyledWrapper,
  StyledInput,
  StyledSearchIconWrapper,
  StyledButton,
} from "./styled";

export type AccountSwitcherSearch = ComponentPropsWithoutRef<"div">;

export const AccountSwitcherSearch: FC<AccountSwitcherSearch> = () => {
  const { setSearchValue, isSearchBarFocus, setSearchBarFocus, searchValue } =
    useAccountSwitcherContext();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { formatMessage } = useIntl();

  const setInputFocus = useCallback(
    (state: boolean) => () => {
      setSearchBarFocus(state);
    },
    [setSearchBarFocus]
  );

  const onInputChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.currentTarget;
      setSearchValue(value);
    },
    [setSearchValue]
  );

  return (
    <CSSTransition in={isSearchBarFocus} nodeRef={wrapperRef} timeout={0}>
      <StyledWrapper ref={wrapperRef}>
        <StyledSearchIconWrapper>
          <Icon name="search" />
        </StyledSearchIconWrapper>
        <StyledInput
          onFocus={setInputFocus(true)}
          defaultValue={searchValue}
          onChange={onInputChange}
          placeholder={formatMessage({ id: "searchForAccount" })}
        />
        <CSSTransition
          in={isSearchBarFocus}
          nodeRef={buttonRef}
          timeout={animationDuration.fast}
        >
          <StyledButton ref={buttonRef} onClick={setInputFocus(false)}>
            {formatMessage({ id: "cancelSearchAccount" })}
          </StyledButton>
        </CSSTransition>
      </StyledWrapper>
    </CSSTransition>
  );
};
